/**
 * Booking API
 *
 * Contact: support@xenoncloud.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type AddonItemAmountBehavior = 'NORMAL' | 'SINGLE' | 'MATCH_GUEST_COUNT';

export const AddonItemAmountBehavior = {
  NORMAL: 'NORMAL' as AddonItemAmountBehavior,
  SINGLE: 'SINGLE' as AddonItemAmountBehavior,
  MATCH_GUEST_COUNT: 'MATCH_GUEST_COUNT' as AddonItemAmountBehavior
};
